import Cycle from '../utilities/cycle';
import { isJSON, getData, putData } from '../utilities/data';

export default class Menu {

  constructor(barba) {
    let self = this;
    
    // Open state
    this.isOpen = false;

    // Menu button
    let menuButtons = document.querySelectorAll('.menu-button-button');
    menuButtons.forEach(el => el.addEventListener('click', () => self.open()));

    // Close button
    let menuCloseButton = document.getElementById('menu-close-button');
    menuCloseButton.addEventListener('click', () => self.close());

    // Project menu controls
    this.projectItems = document.querySelectorAll("#project-menu li");
    this.projectItems.forEach(item => {
      let projectArtworkContainer = document.getElementById("project-artwork-container");
      let projectArtworkContainerImage = projectArtworkContainer.querySelector('img');

      // Hover artworks
      item.addEventListener('mouseenter', () => {
        if (projectArtworkContainer.classList.contains('enlarge')) return; // enlarging, so exit
        projectArtworkContainer.classList.remove('invisible');
        projectArtworkContainer.classList.add('visible');
        if (item.dataset.artwork) {
          if (isJSON(item.dataset.artwork)) {
            let images = JSON.parse(item.dataset.artwork).map(i => {
              return i.image;
            });
            putData(item, 'cycle', new Cycle(projectArtworkContainerImage, images));
          } else {
            projectArtworkContainerImage.src = item.dataset.artwork;
          }
        }
      });
      item.addEventListener('mouseleave', () => {
        if (projectArtworkContainer.classList.contains('enlarge')) return; // enlarging, so exit
        projectArtworkContainer.classList.remove('visible');
        projectArtworkContainer.classList.add('invisible');
        if (isJSON(item.dataset.artwork)) {
          let cycle = getData(item, 'cycle');
          cycle.destroy();
        } else {
          projectArtworkContainerImage.src = '';
        }
      });

      // Clicks
      let link = item.querySelector('a');
      if (link) link.addEventListener('click', event => {

        // Animate project links
        if (link.href.includes('/projects')) {
          event.preventDefault();

          // Bail from current page links
          if (window.location.href.includes(link.href)) {
            projectArtworkContainer.classList.add('enlarge');
            setTimeout(() => window.menu.close(), 450);
            return;
          }

          // If on small screen (mobile) don't animate
          let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
          if (screenWidth > 640) {
            projectArtworkContainer.classList.add('enlarge');
            setTimeout(() => {
              barba.go(link.href);
            }, 700);
          } else {
            barba.go(link.href);
          }
        }
      });
    });
  }

  resetArtwork() {

    // Remove the enlargement class from artwork
    let projectArtworkContainer = document.getElementById("project-artwork-container");
    projectArtworkContainer.classList.remove('enlarge');
    projectArtworkContainer.classList.remove('visible');
    projectArtworkContainer.classList.add('invisible');
  }

  open() {

      // Open the menu
      let menu = document.getElementById('menu');
      menu.classList.remove('closed');
      menu.classList.add('opening');

      // Reset artwork preview state
      this.resetArtwork();

      // Timeout for state reset
      setTimeout(() => {

        // Reset to open
        menu.classList.remove('opening');
        menu.classList.add('open');
      }, 560);
      
      // Set open state
      this.isOpen = true;

      // Lock off vertical overflow
      document.body.style.overflowY = 'hidden';
  }

  close() {
    if (!this.isOpen) return; 

    // Hide the menu
    let menu = document.getElementById('menu');
    menu.classList.remove('open');
    menu.classList.add('closing');

    // Set open state
    this.isOpen = false;

    // Timeout for state reset
    setTimeout(() => {

      // Reset artwork preview state
      this.resetArtwork();

      // Reset to closed
      menu.classList.remove('closing');
      menu.classList.add('closed');
    }, 560);

    // Release vertical overflow for normally scrolling pages
    if (!window.fullPage) document.body.style.overflowY = 'visible';
  }
}



// WEBPACK FOOTER //
// ./source/javascript/sections/menu.js